import type { LeaderboardPage } from "lib/types/leaderboards";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import { useUserData } from "lib/store/user";
import { useState, useEffect } from "react";
import { PaywallWindow } from "lib/types/paywalls";

import DetailHero from "./components/detailHero/detailHero";
import Table from "./components/table/table";
import Spinner from "components/spinner/spinner";
import classNames from "classnames";

type MixPanelProps = {
  [key: string]: string;
};

type LeaderboardDetailViewProps = {
  leaderboard: LeaderboardPage;
  blur: boolean;
  downloadPaywall?: PaywallWindow | null;
};

const LeaderboardDetailView = ({
  leaderboard,
  blur,
  downloadPaywall = null,
}: LeaderboardDetailViewProps) => {
  const { track } = useMixpanelTracking();
  const { isProUser } = useUserData();
  const [isUserStateLoading, setIsUserStateLoading] = useState(true);
  useEffect(() => {
    setIsUserStateLoading(false);
  }, [isProUser]);

  const handleMixpanelTracking = async (
    event: string,
    mixPanelProps: MixPanelProps
  ) => {
    await track(event, mixPanelProps);
  };

  if (isUserStateLoading) return <Spinner />;

  return (
    <div className={"bg-[#F4F4F6]"}>
      <div
        className={classNames("px-5 md:mx-auto md:max-w-[1040px]", {
          "blur-md": blur,
        })}
      >
        <DetailHero
          title={leaderboard.title}
          subtitle={leaderboard.indexDescription}
          data={leaderboard}
          onTrackMixpanel={handleMixpanelTracking}
        />
        <main className={"pb-[100px] pt-[30px]"}>
          <Table
            {...leaderboard}
            onTrackMixpanel={handleMixpanelTracking}
            isProUser={isProUser}
            isPro={leaderboard.isPro || false}
            downloadPaywall={downloadPaywall}
          />
        </main>
      </div>
    </div>
  );
};

export default LeaderboardDetailView;
